<template>
  <div
    class="Overlay"
    :class="{'overlay-zindex': overlay}"
    data-action="close-modal"
    @click.self="closeModal"
    v-if="visible"
  >
    <div
      class="ModalBox ModalBox--central Modal--filters Modal--export"
      :class="{'ModalBox--history' : tabOption === 'HISTORY'}"
      id="NewUserModal"
    >
      <div class="ModalBox-header d-flex d-md-flex justify-content-between align-items-center p-3">
        <div class="Tit Tit--modal position-absolute w-100">
          <span v-t="{path : downloadMode ? 'transactions_action_download' : 'transactions_action_export'}"></span>
        </div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#close-icon"></use>
          </svg>
        </div>
        <div class="d-flex justify-content-between">
          <div
            v-if="showFilters"
            class="d-flex mr-3"
          >
            <button
              v-if="tabOption !== 'HISTORY'"
              @click="showFilterModal"
              class="Fuell-ToolbarButton"
            >
              <span class="Fuell-ToolbarButton--icon">
                <img
                  :src="require('@/assets/img/icons/icon-filter.svg')"
                  alt="filter"
                />
              </span>
              <span class="Fuell-ToolbarButton--label">
                {{ $t('FILTERS') }}
              </span>
              <span
                class="Fuell-ToolbarButton--badge"
                v-if="filtersAmount"
                aria-hidden="true"
              >
                {{ filtersAmount }}
              </span>
            </button>
            <span
              class="Fuell-ToolbarButton remove-container"
              v-if="filtersAmount && tabOption !== 'HISTORY'"
              @click.prevent.stop="emitResetFilters"
            >
              <inline-svg
                style="height:10px;"
                :src="require('@/assets/img/icons/close-menu.svg')"
                alt="remove-filters"
              />
            </span>
          </div>
          <button
            v-if="tabOption !== 'HISTORY'"
            @click="handleExportMode"
            :disabled="downloadDisabled"
            class="Button Button--primary Button--s ml-auto hide-on-responsive"
            :class="{'Button--primary--disabled' : downloadDisabled}"
          >
            <span class="Button-lit">{{$t(downloadButtonlabel)}}</span>
          </button>
        </div>
      </div>
      <div class="ModalBox-container px-3 pt-3">
        <div class="row d-flex justify-content-between p-3 h-100">
          <div class="col-12 mb-3">
            <ul class="Tabs d-flex mx-2">
              <li class="Tabs-itm flex-grow-1">
                <a
                  class="Tabs-itmLink"
                  :class="{ 'Tabs-itmLink--curr': tabOption === 'EXPORT' }"
                  href="#"
                  @click.prevent="tabOption = 'EXPORT'"
                  v-t.preserve="{ path: downloadMode ? 'transactions_export_tab_download_settings' : 'transactions_export_tab_export_settings' }"
                ></a>
              </li>
              <li class="Tabs-itm flex-grow-1">
                <a
                  class="Tabs-itmLink"
                  :class="{ 'Tabs-itmLink--curr': tabOption === 'HISTORY' }"
                  href="#"
                  @click.prevent="tabOption= 'HISTORY'"
                  v-t.preserve="{
                    path: downloadMode ? 'transactions_export_tab_download_history' : 'transactions_export_tab_export_history'
                  }"
                ></a>
              </li>

            </ul>
          </div>

          <template v-if="tabOption === 'EXPORT'">
            <div class="my-2 w-100 d-flex justify-content-center">
              <span
                class="Fuell-Text"
                v-t="{path:'transactions_export_info'}"
              ></span>
            </div>

            <div class="d-flex flex-column date-container mt-3">
              <label class="form--label ml-2">{{$t('transactions_export_date_range_selector_label').toUpperCase()}}</label>
              <date-select
                placeholder="transactions_export_date_range_selector_placeholder"
                periodDefault="noDefault"
                :hiddenPeriods="hiddenPeriods"
                @selectDate="setDate"
                @emitInitialValue="setDate"
                regularExport
              ></date-select>
            </div>
            <div class="w-100 mt-3">
              <p class="Fuell-title-section">{{$t('transactions_export_reference_date')}}</p>
              <p class="Fuell-subtitle-section">{{$t('transactions_export_reference_date_description')}}</p>
              <div class="Fuell-radio-container">
                <input-radio
                  :label="'transactions_export_creation_date'"
                  :value="'createdAt'"
                  :itemValue="referenceDate"
                  @click="setField('referenceDate', $event)"
                ></input-radio>
              </div>
              <div class="Fuell-radio-container">
                <input-radio
                  :label="'transactions_export_expense_date'"
                  :value="'date'"
                  :itemValue="referenceDate"
                  @click="setField('referenceDate', $event)"
                ></input-radio>
              </div>
              <div class="Fuell-radio-container">
                <input-radio
                  :label="'transactions_export_approve_date'"
                  :value="'reviewedAt'"
                  :itemValue="referenceDate"
                  @click="setField('referenceDate', $event)"
                ></input-radio>
              </div>
              <div
                v-if="confirmationDate"
                class="Fuell-radio-container"
              >
                <input-radio
                  :label="'transactions_export_confirmation_date'"
                  :value="'confirmationDate'"
                  :itemValue="referenceDate"
                  @click="setField('referenceDate', $event)"
                ></input-radio>
              </div>
            </div>
            <div
              class="row d-flex justify-content-between mt-3 export-options"
              v-if="!downloadMode || (downloadMode && isAnyTwentyFourSevenCompany && showWhenAvailable)"
            >
              <div class="col-12">
                <p class="Fuell-title-section">{{$t('transactions_export_file_format')}}</p>
                <p class="Fuell-subtitle-section">{{$t('transactions_export_file_format_description')}}</p>
              </div>
              <div class="col-12 Fuell-radio-container">
                <input-radio
                  :label="'transactions_export_default_format'"
                  :value="'FUELL'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>
              <div class="col-12 d-flex Fuell-radio-container">
                <div class="d-flex">
                  <input-radio
                    :label="'transactions_export_default_users_format'"
                    :value="'FUELL_USERS'"
                    :itemValue="exportFormat"
                    @click="handleFuellUsersFormat"
                  />
                </div>
              </div>

              <div class="col-12 Fuell-radio-container">
                <input-radio
                  :label="'transactions_export_holded_format'"
                  :value="'HOLDED'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                  :disabled="!currentCompanyHasHoldedPaymentAccountNumber"
                />
                <i18n
                  class="export-warning text-gray"
                  tag="small"
                  v-if="!currentCompanyHasHoldedPaymentAccountNumber"
                  path="transactions_export_holded_config_not_present"
                >
                  <template v-slot:navigationLink>
                    <span
                      @click="navigateToHoldedConfiguration"
                      class="link"
                      v-t="{path:'transactions_export_holded_config_click_here'}"
                    ></span>
                  </template>
                </i18n>

              </div>
              <div class="col-12 Fuell-radio-container">
                <input-radio
                  :label="'transactions_export_navision_format'"
                  :value="'NAVISION'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />

              </div>
              <div
                class="col-12 Fuell-radio-container"
                v-if="isPlexus"
              >
                <input-radio
                  :label="'transactions_export_plexus_with_tickets_format'"
                  :value="'PLEXUS'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>
              <div
                class="col-12 Fuell-radio-container"
                v-if="isPlexus"
              >
                <input-radio
                  :label="'transactions_export_plexus_without_tickets_format'"
                  :value="'PLEXUS_WITHOUT_TICKETS'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>
              <div
                class="col-12 Fuell-radio-container"
                v-if="isAnyTwentyFourSevenCompany"
              >
                <input-radio
                  :label="'transactions_export_twentyfour_seven_categories_format'"
                  :value="'CATEGORIES_BY_USER'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>
              <div
                class="col-12 Fuell-radio-container"
                v-if="isTalleresGarrido || isTecnocarrocera"
              >
                <input-radio
                  :label="currentCompanyCustomExportLabel"
                  :value="'CUSTOM'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>
              <div
                class="col-12 Fuell-radio-container" v-if="isAnyTwentyFourSevenCompany"
              >
                <input-radio
                  :label="'transactions_export_wrap_file_format'"
                  :value="'WRAP_FILE'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>
              <div
                class="col-12 Fuell-radio-container" v-if="isSmileMedia && showWhenAvailable"
              >
                <input-radio
                  :label="'transactions_export_smile_file_format'"
                  :value="'SMILE'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>

              <div
                class="col-12 Fuell-radio-container" v-if="isRosaGres || isCataloniaCeramica"
              >
                <input-radio
                  :label="'transactions_export_rosa_gres_catalonia_ceramica_format'"
                  :value="'ROSA_GRES'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
              </div>

              <div
                class="col-12 Fuell-radio-container d-flex"
                v-if="currentCompanyHasCustomExportFeature"
              >
                <input-radio
                  :label="'transactions_export_custom_mapping_format'"
                  :value="'CUSTOM_WITHOUT_HISTORY'"
                  :itemValue="exportFormat"
                  @click="setField('exportFormat', $event)"
                />
                <div class="multiselect-custom-field multiselect-custom-field--exportation ml-2">
                  <multiselect
                    v-model="selectedExportSetting"
                    :options="exportSettings"
                    :label="'name'"
                    :placeholder="$t('MULTISELECT_DEFAULT_SELECT_LABEL')"
                    :selectLabel="''"
                    :selectedLabel="''"
                    :disabled="exportFormat !== 'CUSTOM_WITHOUT_HISTORY'"
                  >
                    <div
                      class="caret"
                      slot="caret"
                      slot-scope="{ toggle }"
                      @mousedown.prevent.stop="toggle"
                    >
                      <i
                        class="Ctrl Ctrl--16"
                        aria-hidden="true"
                      >
                        <svg
                          focusable="false"
                          aria-hidden="true"
                          aria-label="Edit"
                        >
                          <use xlink:href="#dropdown-icon"></use>
                        </svg>
                      </i>
                    </div>

                  </multiselect>
                </div>
              </div>
            </div>
            <div class="w-100 mt-3">
              <div class="input--block">
                <label
                  for=""
                  class="form--label"
                >{{$t('transactions_export_email_to_notify').toUpperCase()}}</label>
                <div
                  class="Form-field"
                  :class="{'Form--field-error' : $v.exportEmail.$error}"
                >
                  <input
                    type="email"
                    v-model.trim="exportEmail"
                    :placeholder="$t('EMAIL')"
                    @blur="$v.exportEmail.$touch()"
                    class="Input-text"
                  >
                </div>
              </div>
            </div>

            <div
              v-if="(isAdmin || isBookKeeper) && !downloadMode"
              class="col-12 mt-2"
            >
              <label
                class="Checkbox justify-content-start"
                :class="{'SubOpts-itm--selected' : enableLock}"
              >
                <input
                  class="Checkbox-input"
                  type="checkbox"
                  name="col-otps"
                  v-model="enableLock"
                >
                <i
                  class="Checkbox-customIcon d-none"
                  aria-hidden="true"
                ></i>
                <i
                  class="Checkbox-customIcon"
                  aria-hidden="true"
                  :class="{'Checkbox-customIcon--selected' : enableLock}"
                ></i>
                <span
                  class="Checkbox-lit ml-2"
                  v-t="{path: 'transactions_export_action_export_and_lock'}"
                ></span>
              </label>

              <div
                class="help-text"
                v-t="{path: 'transactions_export_action_export_and_lock_help'}"
              ></div>
            </div>
            <div class="footer-responsive w-100">
              <button
                v-if="tabOption !== 'HISTORY'"
                @click="handleExportMode"
                :disabled="downloadDisabled"
                class="Fuell-Button blue block mt-3"
              >
                <span class="Button-lit">{{$t(downloadButtonlabel)}}</span>
              </button>
            </div>
          </template>
          <template v-else>
            <transactions-export-history />
          </template>
          <div
            class="d-flex w-100 justify-content-center"
            v-if="isExporting"
          >
            <div class="d-flex flex-column align-items-center justify-content-center">
              <spinner></spinner>
              <small v-t.preserve="{path: 'ACTION_EXPORT_IN_PROGRESS'}"></small>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import _transactionExportDownloadModal from '@/modules/transactions/_mixins/_transactionExportDownloadModal'
import DateSelect from '@/components/Commons/Forms/DateSelect.vue'
import Multiselect from 'vue-multiselect'

import Spinner from '@/components/Commons/Spinner'
import transactionsApi from '../../_api'
import InputRadio from '@/components/Commons/Forms/InputRadio'
import InlineSvg from 'vue-inline-svg'
import TransactionsExportHistory from '../export/TransactionsExportHistory.vue'

import { segmentTrack } from '@/analytics/segment'

import { COMPANIES_WITH_SPECIFIC_FEATURES, CUSTOM_EXPORT_SETTINGS_PER_COMPANY } from '../../_constants/constants'

import exportApi from '@/modules/export/_api'
const { validationMixin } = require('vuelidate')
const { email } = require('vuelidate/lib/validators')

export default {
  name: 'TransactionsExportModal',
  mixins: [_modalHandlerMixin, _transactionExportDownloadModal, validationMixin],
  components: { DateSelect, Spinner, InputRadio, Multiselect, TransactionsExportHistory, InlineSvg },
  props: {
    isReimbursement: {
      type: Boolean,
      default: false
    },
    transactionStatus: {
      type: String
    },
    downloadMode: {
      type: Boolean,
      default: false
    },
    defaultTab: {
      type: String,
      default: 'EXPORT'
    },
    extraFilters: {
      type: Object,
      default: () => { }
    },
    confirmationDate: {
      type: Boolean,
      default: false
    },
    expenses: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    },
    showFilters: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      exportDateRange: {},
      minDate: '',
      maxDate: '',
      isExporting: false,
      enableLock: false,
      mask: {
        input: ['DD/MM/YYYY', 'DD/MM/YY']
      },
      exportFormat: 'FUELL',
      showEmailField: false,
      tabOption: 'EXPORT',
      exportEmail: null,
      exportSettings: [],
      selectedExportSetting: null,
      // TODO : REMOVE WHEN IMPLEMENTED
      showWhenAvailable: false
    }
  },
  computed: {
    currentCompanyHasHoldedPaymentAccountNumber () {
      const companyHoldedConfig = this.$store.getters['CompanyStore/currentCompanyConfigs'].find(el => el.code === 'HOLDED_ERP')
      return !!((companyHoldedConfig && companyHoldedConfig.config && companyHoldedConfig.config.paymentAccountNumber))
    },
    downloadDisabled () {
      return !this.minDate || !this.maxDate || this.$v.exportEmail.$error || (this.exportFormat === 'CUSTOM_WITHOUT_HISTORY' && !this.selectedExportSetting)
    },
    transactionFileName () {
      let transactionFileLabel = 'Export_GG_'

      switch (this.exportFormat) {
        case 'HOLDED': transactionFileLabel += 'Holded'
          break
        case 'NAVISION': transactionFileLabel += 'Navision'
          break
        case 'PLEXUS': transactionFileLabel += 'Plexus'
        break
        case 'ROSA_GRES' : transactionFileLabel += 'Para contabilidad'
      }
      return transactionFileLabel
    },
    downloadButtonlabel () {
      return this.downloadMode ? 'transactions_export_request_download' : 'transactions_export_request_export'
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    isPlexus () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'PLEXUS')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isAnyTwentyFourSevenCompany () {
       return this.isTwentyfourSeven || this.isTwentyfourSevenCanarian || this.isSmileMedia || this.isTwentyfourSevenPortugal || this.isTwentyfourSevenSevenIslandFilms
    },
    isTwentyfourSeven () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTwentyfourSevenCanarian () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN_CANARIAN')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isSmileMedia () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'SMILE_MEDIA')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTwentyfourSevenPortugal () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN_PORTUGAL')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTalleresGarrido () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TALLERES_GARRIDO')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTecnocarrocera () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TECNOCARROCERA')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isTwentyfourSevenSevenIslandFilms () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'TWENTYFOUR_SEVEN_SEVEN_ISLAND_FILMS')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isRosaGres () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'ROSA_GRES')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    isCataloniaCeramica () {
      let { id } = COMPANIES_WITH_SPECIFIC_FEATURES.find(el => el.company === 'CATALONIA_CERAMICA')
      return this.$store.getters['CompanyStore/currentCompany'].id === id
    },
    currentCompanyHasCustomExportFeature () {
      let activatedFeatures = this.$store.getters['CompanyStore/currentCompany'].activatedFeatures || false
      let hasExportFunnelFeature = activatedFeatures ? activatedFeatures.findIndex(el => el.feature?.code === 'EXPORT_FUNNEL_FEATURE') > -1 : false
      return hasExportFunnelFeature
    },
    currentCompanyCustomExportLabel () {
      let currentCompanyCustomExportLabel = ''
      if (this.isTalleresGarrido) {
        currentCompanyCustomExportLabel = 'transactions_export_talleres_garrido_format'
      }
      if (this.isTecnocarrocera) {
        currentCompanyCustomExportLabel = 'transactions_export_tecnocarrocera_format'
      }
      return currentCompanyCustomExportLabel
    }
  },
  methods: {
    navigateToHoldedConfiguration () {
      const erp = 'holded'
      this.$router.push({ name: 'integration_detail', params: { erp } })
    },
    handleExportMode () {
      this.fetchCsv()
    },
    handleFuellUsersFormat () {
      this.showEmailField = true
      this.exportFormat = 'FUELL_USERS'
    },
    async fetchCsv () {
      if (this.isExporting) return

      let filters = {
        'status.code': this.transactionStatus === 'OK' ? ['OK', 'PENDING'] : 'KO'
      }
      if (this.transactionStatus === 'OK') {
        filters['status.code'] = ['OK', 'PENDING']
      }

      if (this.transactionStatus === 'KO') {
        filters['status.code'] = 'KO'
      }

      if (this.enableLock) {
        filters['lock'] = true
      }
      let transactionFilters = {
        ...this.currentTransactionFilters
      }

      if (this.referenceDate) {
        filters[`${this.referenceDate}[after]`] = this.minDate
        filters[`${this.referenceDate}[before]`] = this.maxDate
      }
      if (transactionFilters['type.code']) {
        delete transactionFilters['type.code']
      }
      let filtersFinal = {
        ...transactionFilters,
        ...filters
      }
      if (this.exportEmail) {
        filtersFinal['notificationEmails'] = this.exportEmail
      }
      this.isExporting = true

      if (this.exportFormat === 'FUELL') {
        filtersFinal['exportTypeCode'] = 'NORMAL'
      }
      if (this.exportFormat === 'HOLDED') {
        filtersFinal['exportTypeCode'] = 'HOLDED'
      }
      if (this.exportFormat === 'NAVISION') {
        filtersFinal['exportTypeCode'] = 'NAVISION'
      }
      if (this.exportFormat === 'FUELL_USERS') {
        filtersFinal['exportTypeCode'] = 'COMPLETE'
      }
      if (this.exportFormat === 'PLEXUS') {
        filtersFinal['exportTypeCode'] = 'PLEXUS'
      }
      if (this.exportFormat === 'PLEXUS_WITHOUT_TICKETS') {
        filtersFinal['exportTypeCode'] = 'PLEXUS_WITHOUT_TICKETS'
      }
      if (this.exportFormat === 'CATEGORIES_BY_USER') {
        filtersFinal['exportTypeCode'] = 'CATEGORIES_BY_USER'
      }
      if (this.exportFormat === 'CUSTOM_WITHOUT_HISTORY') {
        filtersFinal['exportTypeCode'] = 'CUSTOM_WITHOUT_HISTORY'
        filtersFinal['exportSettingId'] = this.selectedExportSetting.id
      }
      if (this.exportFormat === 'CUSTOM') {
        filtersFinal['exportTypeCode'] = 'CUSTOM'
        if (this.isTalleresGarrido) {
          filtersFinal['exportSettingId'] = CUSTOM_EXPORT_SETTINGS_PER_COMPANY.find(setting => setting.company === 'TALLERES_GARRIDO')?.exportSettingId
        }
        if (this.isTecnocarrocera) {
          filtersFinal['exportSettingId'] = CUSTOM_EXPORT_SETTINGS_PER_COMPANY.find(setting => setting.company === 'TECNOCARROCERA')?.exportSettingId
        }
      }
      if (this.exportFormat === 'WRAP_FILE') {
        filtersFinal['exportTypeCode'] = 'WRAP_FILE'
      }

      if (this.exportFormat === 'SMILE') {
         filtersFinal['exportTypeCode'] = 'SMILE'
      }

       if (this.exportFormat === 'ROSA_GRES') {
         filtersFinal['exportTypeCode'] = 'ROSA_GRES'
      }

      if (this.isAnyTwentyFourSevenCompany) {
        delete this.extraFilters['exportTypeCode']
        // delete this.extraFilters['downloadTypeCode']
      }
      if (this.downloadMode) {
        filtersFinal = { ...filtersFinal, ...this.extraFilters }
      }
      if (this.referenceDate !== 'date') {
        delete filtersFinal['date[after]']
        delete filtersFinal['date[before]']
      }
      if (this.referenceDate !== 'createdAt') {
        delete filtersFinal['createdAt[after]']
        delete filtersFinal['createdAt[before]']
      }
      try {
        await transactionsApi.getExportBackground(filtersFinal)
        this.$store.dispatch('SnackBars/addSuccess', this.$t('transactions_export_success'))
        segmentTrack('Export transactions', {
          days_in_range: this.$moment.utc(this.exportDateRange['date[before]']).diff(this.exportDateRange['date[after]'], 'days'),
          block_transactions: !!filters['lock']
        })
        if (this.enableLock) {
          this.$emit('updateTransactions')
        }
        this.closeModal()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transactions_export_error' }, { root: true })
      } finally {
        this.isExporting = false
      }
    },
    getDateCustomLabel (item) {
      if (item && item.date) {
        let formattedClosureDate = this.$moment.utc(item.flex_rem_closure_date).format()
        const month = this.$i18n.d(new Date(formattedClosureDate), 'month')
        const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1)
        return `${capitalizedMonth}`
      }
    },
    setSelectedExportSetting (event) {
      this.selectedExportSetting = event
    },
    async fetchExportSettings () {
      try {
        const response = await exportApi.getExportationFlows()
        this.exportSettings = [...response.data]
      } catch (error) {
        console.error(error)
      }
    }
  },
  async created () {
    this.tabOption = this.defaultTab
    await this.fetchExportSettings()
  },
  validations: {
    exportEmail: { email }
  }

}
</script>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect-custom-field--exportation .multiselect__tags {
  min-width: 200px;
  height: 32px;
}
.multiselect-custom-field--exportation,
.multiselect-custom-field--exportation .multiselect,
.multiselect-custom-field--exportation .multiselect__tags,
.multiselect-custom-field--exportation .caret,
.multiselect-custom-field--exportation .multiselect__placeholder {
  height: 32px;
  min-height: 32px;
}
.multiselect-custom-field--exportation .multiselect__placeholder {
  margin: 0;
}
</style>
<style scoped lang="scss">
.overlay-zindex {
  z-index: 9999;
}
.date-select-filter {
  width: 383px;
}
.ModalBox.Modal--export {
  max-height: 623px;
  overflow: auto;
  .ModalBox-header {
    position: sticky;
  }
}
.Fuell-title-section {
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-heading);
}
.Fuell-subtitle-section {
  margin-bottom: 4px;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-body);
}
.Fuell-radio-container {
  margin-bottom: 4px;
  align-items: center;
  .Label {
    line-height: 14px;
  }
  label {
    padding: 0 !important;
  }
}
.export-warning {
  color: var(--gray);
  margin-left: 28px;
}
.link {
  color: var(--blue-action-1-active);
  text-decoration: underline;
  cursor: pointer;
}
.ModalBox {
  max-height: 835px;
  width: 800px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
}
.input--block {
  max-width: 368px;
}
.input--block--full {
  max-width: 100%;
}
.Checkbox-lit {
  font-weight: 300;
  font-size: 15px;
}
.help-text {
  color: var(--gray);
  font-weight: 300;
  font-size: 13px;
  margin-left: 24px;
  margin-top: -10px;
}

.remove-container {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.date-container > .Form-field {
  width: 100%;
}
.date-container {
  margin-bottom: 8px;
}
.footer-responsive {
  display: none;
}

@media (max-width: 575px) {
  .input--block {
    width: 100%;
    max-width: 75vw;
  }
  .ModalBox {
    height: 100vh;
    max-height: 100vh;
    width: 100vw;
    max-width: 100vw;
    overflow-y: auto;
  }
  .Tabs {
    flex-direction: column;
    margin-bottom: 10px !important;
  }
  .hide-on-responsive {
    display: none;
  }
  .footer-responsive {
    display: block;
  }
  .Checkbox-customIcon {
    width: 20px;
  }
}
@media (min-width: 576px) and (max-width: 992px) {
  .input--block {
    max-width: 49%;
  }
}
</style>
